export const UserLocalKey = 'user_profile';

export function getUser() {
  const storage = window.localStorage.getItem(UserLocalKey);
  if (!storage) return null;
  return JSON.parse(storage);
}

export function setUser(user) {
  window.localStorage.setItem(UserLocalKey, JSON.stringify(user));
}

export function removeUser() {
  window.localStorage.removeItem(UserLocalKey);
}
